<template>
  <myhead :value="value" @next="next" @lookmore="more">{{ $route.query.title || $route.meta.title}}</myhead>
  <div class="vh5"></div>
  <div class="size14">
    <div class="flex cen mb30">
      是否显示显示商城模块
      <van-switch size="20px" class="ml20" v-model="goods_btn" />
    </div>
    <div v-for="itemList,listindex in list" :key="listindex" class="BGwhite ml15 mr15 mb12 pad12 radius5">
      <div class="b500">
        <p v-if="listindex=='yes'">已添加模块</p>
        <p v-if="listindex=='no'">未添加模块</p>
      </div>
      <div class="center grid4 size12 gap8">
        <div v-for="item,index in itemList" :key="index" class="mt10 relative" @click="setMenu(index,listindex)">
          <img src="@/assets/img/icon28.png" class="absolute r t height16px mr15" alt="" v-if="listindex=='yes'">
          <img src="@/assets/img/icon29.png" class="absolute r t height16px mr15" alt="" v-else>
          <img :onerror="imgError" class="block auto height30px mb5" :src="item.thumb" alt="">
          {{item.name}}
        </div>
      </div>
    </div>
  </div>
  <div class="flex cen center line30 mt25 size14">
    <!-- <div class="width60px Con">取消</div> -->
    <div class="width60px radius5 ml20 Cfff BGon" @click="save">保存</div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      goods_btn: false,
      list: {}
    }
  },
  watch: {
  },
  methods: {
    setMenu (index, status) {
      let item = this.list[status].splice(index, 1)
      if (status == 'no') {
        this.list['yes'] = this.list['yes'].concat(item);
      } else {
        this.list['no'] = this.list['no'].concat(item);
      }
    },
    save () {
      this.ajax({
        method: "post",
        url: "users/menu",
        data: {
          goods_btn: this.goods_btn ? 1 : 0,
          menu: this.list.yes.map(item => item.id).join(',')
        },
        myData: {
          showMsg: true
        }
      }).then(res => {
        if (res.errcode == 1) {
          setTimeout(() => {
            this.$router.push('/me')
          }, 500)
        }
      })
    },
    apply () {
      this.showDialog({
        showCancelButton: true,
        cancelButtonText: "退出申请",
        confirmButtonText: "重新选择",
        message: '抱歉！您的观点不符合本网站经营理念\n感谢您的参与!',
      }).then(() => {
      }).catch(() => {
      });
    },
    next () {
      console.log("下一步")
    }
  },
  created () {
    this.ajax.post("users/getmenu").then(({ data }) => {
      let { goods_btn, notadded_list, added_list } = data;
      this.goods_btn = goods_btn ? true : false;
      this.list = { yes: added_list, no: notadded_list }
    })
  }
}
</script>
<style scoped>

</style>
